import React from 'react'
import PropTypes from 'prop-types'
import styled from '@xstyled/styled-components'
import { GatsbyImage } from "gatsby-plugin-image";

const StyledImage = styled.div`
  img {
    max-width: 100%;
    height: auto;
  }
`

const ParagraphFullWidthImage = ({ src, alt }) => {
  return (
    <StyledImage>
      <GatsbyImage image={src} alt={alt} />
    </StyledImage>
  );};

export default ParagraphFullWidthImage

ParagraphFullWidthImage.defaultProps = {
  src: '',
  alt: ''
};

ParagraphFullWidthImage.propTypes = {
  src: PropTypes.shape({
    aspectRatio: PropTypes.number,
    base64: PropTypes.string,
    sizes: PropTypes.string,
    src: PropTypes.string,
    srcSet: PropTypes.string,
    srcSetWebp: PropTypes.string,
    srcWebp: PropTypes.string,
  }).isRequired,
  alt: PropTypes.string.isRequired
};
